import { context } from '@wikia/ad-engine';

export function getWebadsContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[320, 50],
						[320, 100],
					],
					placementId: '648079843898112402b6dfdc_6477669cfd7c540d4d3e1d67',
				},
			};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.mobile_top_leaderboard ?? [
					[320, 50],
					[320, 100],
				],
				placementId: '648079843898112402b6dfdc_647766970ee778cdfd3e1d66',
			},
			mobile_prefooter: {
				sizes: [[300, 250]],
				placementId: '648079843898112402b6dfdc_6477668ef53dfce3373e1d65',
			},
			...floorAdhesionConfigs,
			featured: {
				placementId: '648079843898112402b6dfdc_647766a916faafcac33e1d68',
			},
		},
	};
}
